import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenLocationFilterComponent } from "./components/loren-location-filter/loren-location-filter.component";
import { LorenLocationFilterDialogModule } from "../loren-location-filter-dialog/loren-location-filter-dialog.module";

@NgModule({
  declarations: [LorenLocationFilterComponent],
  exports: [LorenLocationFilterComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    LorenLocationFilterDialogModule,
    MatMenuModule,
    TranslocoModule,
  ],
})
export class LorenLocationFilterModule {}
